// @ts-check
import { Link } from 'react-router-dom';
import { formatDay, formatRupees, label } from '../../utils/wholesale';
import { card, DeadlineBadge, DeliveryBadge, StageBadge } from './shared';

const TH = 'px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase whitespace-nowrap';

/** @param {{partners: any[]}} props */
const PartnersTable = ({ partners }) => (
  <div className={`${card} overflow-x-auto`}>
    <table className="w-full">
      <thead className="bg-muted/50 border-b border-border">
        <tr>
          <th className={TH}>Name</th>
          <th className={TH}>City</th>
          <th className={TH}>Kind</th>
          <th className={TH}>Tier</th>
          <th className={TH}>Stage</th>
          <th className={`${TH} text-right`}>Days</th>
          <th className={TH}>Next action</th>
          <th className={TH}>On</th>
          <th className={`${TH} text-right`}>Best net</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-border">
        {partners.map((p) => (
          <tr key={p.id} className={`hover:bg-muted/50 ${p.is_archived ? 'text-muted-foreground' : ''}`}>
            <td className="px-4 py-3 text-sm font-medium">
              <Link to={`/wholesale/${p.id}`} className="hover:underline">
                {p.name}
              </Link>
              {(p.days_to_deadline !== null && p.days_to_deadline !== undefined) || p.deadline_passed ? (
                <span className="ml-2">
                  <DeadlineBadge item={p} />
                </span>
              ) : null}
              {p.email_delivery ? (
                <span className="ml-2">
                  <DeliveryBadge delivery={p.email_delivery} />
                </span>
              ) : null}
              {p.open_reminders > 0 && (
                <span className="ml-2 text-xs px-1.5 rounded bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-300">
                  {p.open_reminders} due
                </span>
              )}
            </td>
            <td className="px-4 py-3 text-sm">{p.city || '—'}</td>
            <td className="px-4 py-3 text-sm">{label(p.kind)}</td>
            <td className="px-4 py-3 text-sm">{label(p.price_tier)}</td>
            <td className="px-4 py-3">
              <StageBadge stage={p.stage} />
            </td>
            <td className="px-4 py-3 text-sm text-right">{p.days_in_stage}</td>
            <td className="px-4 py-3 text-sm max-w-xs truncate" title={p.next_action || ''}>
              {p.next_action || '—'}
            </td>
            <td className="px-4 py-3 text-sm whitespace-nowrap">{formatDay(p.next_action_on)}</td>
            <td className="px-4 py-3 text-sm text-right">{formatRupees(p.best_net_per_piece)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default PartnersTable;
